import { render, staticRenderFns } from "./CellRenderPeriod.vue?vue&type=template&id=1fb56443&scoped=true&"
var script = {}
import style0 from "./CellRenderPeriod.vue?vue&type=style&index=0&id=1fb56443&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb56443",
  null
  
)

export default component.exports